import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = null | 'privacy' | 'terms';
const privacyContent = <>
    <h3 className="text-2xl font-playfair font-bold text-white mb-6" data-id="element-34">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-[#a0a0b0] font-inter leading-relaxed text-sm" data-id="element-35">
      <p data-id="element-36">
        <strong className="text-white" data-id="element-37">Última actualización:</strong> Marzo 2026
      </p>
      <p data-id="element-38">
        Tu privacidad es importante para nosotros. Esta Política de Privacidad
        describe cómo recopilamos, usamos y protegemos tu información personal
        cuando utilizas nuestro sitio web y adquieres nuestros productos
        digitales.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-39">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-40">
        Recopilamos información que nos proporcionas directamente al realizar
        una compra, incluyendo tu nombre, dirección de correo electrónico e
        información de pago. No almacenamos datos de tarjetas de crédito; estos
        son procesados de forma segura por nuestro proveedor de pagos.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-41">
        2. Uso de la Información
      </h4>
      <p data-id="element-42">
        Utilizamos tu información para: procesar tu compra y entregar el
        producto digital, enviarte confirmaciones de pedido, y comunicarnos
        contigo sobre actualizaciones del producto si has dado tu
        consentimiento.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-43">
        3. Protección de Datos
      </h4>
      <p data-id="element-44">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-45">4. Cookies</h4>
      <p data-id="element-46">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-47">
        5. Tus Derechos
      </h4>
      <p data-id="element-48">
        Tienes derecho a acceder, rectificar o eliminar tu información personal.
        También puedes solicitar la portabilidad de tus datos o retirar tu
        consentimiento en cualquier momento.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-49">
        6. Cambios a esta Política
      </h4>
      <p data-id="element-50">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Te notificaremos sobre cambios significativos a través del
        correo electrónico proporcionado.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-playfair font-bold text-white mb-6" data-id="element-51">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-[#a0a0b0] font-inter leading-relaxed text-sm" data-id="element-52">
      <p data-id="element-53">
        <strong className="text-white" data-id="element-54">Última actualización:</strong> Marzo 2026
      </p>
      <p data-id="element-55">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, aceptas cumplir con estos Términos y Condiciones. Por favor,
        léelos cuidadosamente antes de realizar tu compra.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-56">
        1. Producto Digital
      </h4>
      <p data-id="element-57">
        El "Protocolo Adiós Azúcar" es un producto digital informativo en
        formato PDF. El contenido es de carácter educativo y no sustituye el
        consejo médico profesional. Consulta siempre a un profesional de la
        salud antes de realizar cambios en tu dieta.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-58">
        2. Entrega del Producto
      </h4>
      <p data-id="element-59">
        Tras completar el pago, recibirás acceso instantáneo al producto digital
        a través de un enlace de descarga enviado a tu correo electrónico. Es tu
        responsabilidad proporcionar una dirección de correo válida.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-60">
        3. Política de Reembolso
      </h4>
      <p data-id="element-61">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Sin embargo, si experimentas problemas técnicos para acceder al
        producto, nos comprometemos a resolverlos de manera oportuna.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-62">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-63">
        Todo el contenido del producto está protegido por derechos de autor. No
        está permitido reproducir, distribuir o compartir el material sin
        autorización expresa por escrito.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-64">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-65">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. El uso del protocolo es bajo tu propia
        responsabilidad. Este producto no está diseñado para diagnosticar,
        tratar o curar ninguna condición médica.
      </p>
      <h4 className="text-white font-semibold text-base pt-2" data-id="element-66">
        6. Modificaciones
      </h4>
      <p data-id="element-67">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor inmediatamente después de su
        publicación en el sitio web.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 bg-[#060609] border-t border-white/5" data-id="element-68">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-69">
          <button onClick={() => setActiveModal('privacy')} className="text-[#a0a0b0] hover:text-[#00d4ff] font-inter text-sm transition-colors duration-200" data-id="element-70">
            Política de Privacidad
          </button>
          <span className="hidden sm:block text-[#a0a0b0]/30" data-id="element-71">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-[#a0a0b0] hover:text-[#00d4ff] font-inter text-sm transition-colors duration-200" data-id="element-72">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-center text-[#a0a0b0]/40 font-inter text-xs mt-4" data-id="element-73">
          © {new Date().getFullYear()} Protocolo Adiós Azúcar. Todos los
          derechos reservados.
        </p>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-74">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-75">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-[#12121e] border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-76">
              {/* Modal Header */}
              <div className="flex items-center justify-end p-4 border-b border-white/5" data-id="element-77">
                <button onClick={() => setActiveModal(null)} className="text-[#a0a0b0] hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5" aria-label="Cerrar" data-id="element-78">
                  <XIcon className="w-5 h-5" data-id="element-79" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(80vh-60px)]" data-id="element-80">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}